import axios from 'axios'

export default {
    indexReseller (resellerId) {
        return axios.get(`/api/resellers/${resellerId}/clients`)
    },
    indexUser (userId) {
        return axios.get(`/api/users/${userId}/clients`)
    },
    index (resellerEntityId) {
        return axios.get(`/api/entities/${resellerEntityId}/clients`)
    },
    store (resellerEntityId, data) {
        return axios.post(`/api/entities/${resellerEntityId}/clients`, data)
    },
    update (clientId, data) {
        return axios.put(`/api/clients/${clientId}`, data)
    },
    delete (clientId) {
        return axios.delete(`/api/clients/${clientId}`)
    }
}